import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { selectContentTotalLength } from '~src/spacesPlatform/selectors/ContentSelectors';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { AllSitesSpace, AllSitesSpaceDispatchProps, AllSitesSpaceStateProps } from './AllSitesSpace';

const mapStateToProps: MapStateToProps<AllSitesSpaceStateProps> = (state: AppState) => ({
  numberOfFetchedSites: selectContentTotalLength(state),
  isBusyFetchingItems: state.contentExplorer.content.isBusy,
});

const mapDispatchToProps: MapDispatchToProps<AllSitesSpaceDispatchProps> = (dispatch) => bindActionCreators({
  requestSpaceContents,
}, dispatch);

export const ConnectedAllSitesSpace: React.ComponentClass<{}>
  = connect(mapStateToProps, mapDispatchToProps)(AllSitesSpace);
